import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'lgv-formly-phone-number',
  templateUrl: './formly-phone-number.component.html',
  styleUrls: ['./formly-phone-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyPhoneNumberComponent  extends FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super(); 
  }

  ngOnInit(): void {
    this.formControl.addValidators(Validators.minLength(10));
    this.formControl.addValidators(Validators.maxLength(10));
  }

}
